import React, { Component } from 'react';
import { ToggleSmall, Modal, Checkbox } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { Breadcrumb, Card } from '../../../../components';
import {
  insertDmService,
  getByDmService,
  updateDmService,
  deleteDmService,
} from '../../../../services/Api';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      name: '',
      description: '',
      manager: '',
      labelForm: 'Nome do grupo',
      placeForm: 'Digite aqui o nome do grupo',
      openMdDelete: false,
      MultSelecaoTamanhos: false,
      ConcluirNoFechamentoArquivo: false,
      FormaPagamentoOpcional: false,
      DataDesejadaOpcional: false,
      UtilizadoEmTrade: false,
      Logistica: false,
    };
  }

  componentWillMount() {
    this.managerVisited();
    this.getItem();
  }

  managerVisited = () => {
    const { match: propMatch } = this.props;
    const urlVisited = propMatch.url;
    const group = urlVisited.match(/grupo/);
    if (group) {
      this.setState({
        manager: 'group',
      });
    } else {
      this.setState({
        manager: 'category',
      });
    }
  };

  getItem = async () => {
    const { match } = this.props;
    const urlId = match.params && match.params.id;
    const result = await getByDmService('/ProdutoCategoria', urlId);
    const {
      ativo,
      descricao,
      nome,
      multSelecaoTamanhos,
      concluirNoFechamentoArquivo,
      formaPagamentoOpcional,
      dataDesejadaOpcional,
      utilizadoEmTrade,
      horas,
      logistica
    } = result;

    this.setState({
      active: ativo,
      name: nome,
      horas,
      description: descricao,
      MultSelecaoTamanhos: multSelecaoTamanhos,
      ConcluirNoFechamentoArquivo: concluirNoFechamentoArquivo,
      FormaPagamentoOpcional: formaPagamentoOpcional,
      DataDesejadaOpcional: dataDesejadaOpcional,
      UtilizadoEmTrade: utilizadoEmTrade,
      Logistica: logistica
    });
  };

  onToogle = () => {
    const { match } = this.props;
    const { active } = this.state;
    // const urlId = match.params && match.params.id;
    this.setState(
      prevState => ({
        active: !prevState.active,
      }),
      async () => {
        try {
          await updateDmService('ProdutoCategoria/AlteraStatus', match.params.id, null);
        } catch (e) {
          this.setState({ active });
          toast.warn('Ocorreu uma falha ao tentar trocar o status do item');
        }
      },
    );
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  saveCategory = async e => {
    e.preventDefault();
    const { name, description, horas } = this.state;
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;
    const urlEdit = `/ProdutoCategoria/`;

    const formData = {
      tipo: 2,
      nome: name,
      horas,
      descricao: description,
    };

    try {
      if (urlId) {
        await updateDmService(urlEdit, urlId, formData);
        history.goBack();
        toast.success('Edição realizada com sucesso.');
      } else {
        await insertDmService(urlEdit, formData);
        history.goBack();
        toast.success('Categoria salva com sucesso.');
      }
    } catch (error) {
      toast.warn('Desculpe-nos. Ocorreu alguma falha ao tentar salvar os dados');
    }
  };

  saveGroup = async e => {
    e.preventDefault();
    const { name, horas } = this.state;
    const { match, history } = this.props;
    const {
      MultSelecaoTamanhos,
      ConcluirNoFechamentoArquivo,
      FormaPagamentoOpcional,
      DataDesejadaOpcional,
      UtilizadoEmTrade,
      Logistica
    } = this.state;
    const urlId = match.params && match.params.id;
    const urlEdit = `/ProdutoCategoria/`;

    const formData = {
      tipo: 1,
      nome: name,
      horas,
      MultSelecaoTamanhos,
      ConcluirNoFechamentoArquivo,
      FormaPagamentoOpcional,
      DataDesejadaOpcional,
      UtilizadoEmTrade,
      Logistica
    };
    try {
      if (urlId) {
        await updateDmService(urlEdit, urlId, formData);
        history.goBack();
        toast.success('Edição realizada com sucesso.');
      } else {
        await insertDmService(urlEdit, formData);
        history.goBack();
        toast.success('Grupo salvo com sucesso.');
      }
    } catch (error) {
      toast.warn('Desculpe-nos. Ocorreu alguma falha ao tentar salvar os dados');
    }
  };

  modalDelete = () => {
    this.setState(prevState => ({
      openMdDelete: !prevState.openMdDelete,
    }));
  };

  delete = async () => {
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;

    try {
      await deleteDmService('/ProdutoCategoria', urlId);
      toast.success('Deletado conforme o solicitado.');
      history.goBack();
    } catch (error) {
      toast.error('Um erro inesperado ocorreu ao tentar deletar');
    }
  };

  onChangeCheck = (val, id, event) => {
    this.setState({ [event.target.name]: val });
  };

  render() {
    const {
      active,
      name,
      horas,
      description,
      labelForm,
      placeForm,
      manager,
      openMdDelete,
      MultSelecaoTamanhos,
      ConcluirNoFechamentoArquivo,
      FormaPagamentoOpcional,
      DataDesejadaOpcional,
      UtilizadoEmTrade,
      Logistica
    } = this.state;

    const { history, match } = this.props;
    const urlId = match.params && match.params.id;
    const titleDefault = urlId ? 'Editar' : 'Criar';
    const titleBread =
      manager === 'group'
        ? `${titleDefault}  Grupo (produtos agência)`
        : `${titleDefault} Categoria`;
    const descriptionBread =
      manager === 'group' ? 'Gerencie grupos de produtos agência.' : 'Gerencie grupos de produtos';

    return (
      <div>
        {urlId ? (
          <Breadcrumb
            title={titleBread}
            description={descriptionBread}
            renderRight={(() => (
              <div className="flex v-sm-margin">
                <label
                  htmlFor="toogle-active"
                  className={`${active ? 'text-info ' : 'text-warning'} label-toogle-active`}
                >
                  {active ? 'Ativo' : 'Inativo'}
                </label>
                <ToggleSmall
                  id="toogle-active"
                  className="toogle-active"
                  toggled={active}
                  ariaLabel="Ativo"
                  onClick={() => this.onToogle()}
                />
                <button
                  className="bx--btn btn-primary-outlined h-sm-margin"
                  type="button"
                  onClick={() => this.modalDelete()}
                >
                  Remover
                </button>
              </div>
            ))()}
            renderLeft={(() => (
              <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        ) : (
          <Breadcrumb
            title={titleBread}
            description={descriptionBread}
            renderLeft={(() => (
              <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        )}

        <Card className="center-box">
          <form onSubmit={manager === 'group' ? this.saveGroup : this.saveCategory}>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin">{labelForm}</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder={placeForm}
                  name="name"
                  value={name}
                  onChange={this.onChangeText}
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin">Horas para criação da arte</label>
                <input
                  type="number"
                  className="bx--text-input"
                  required
                  placeholder="Quantidade de horas"
                  name="horas"
                  pattern="\d{1,5}"
                  value={horas}
                  onChange={this.onChangeText}
                />
              </div>
            </div>
            {manager === "group" && (
              <div>
                <div className="bx--col-md-12 bx--col-xs-12 mg-left-20">
                  <Checkbox
                    className=" check-uniq"
                    labelText="Permitir multiseleção de tamanhos"
                    id="MultSelecaoTamanhos"
                    name="MultSelecaoTamanhos"
                    checked={MultSelecaoTamanhos}
                    onChange={this.onChangeCheck}
                  />
                </div>
                <div className="bx--col-md-12 bx--col-xs-12 mg-left-20">
                  <Checkbox
                    className=" check-uniq"
                    labelText="Concluir pedido no fechamento de arquivo"
                    id="ConcluirNoFechamentoArquivo"
                    name="ConcluirNoFechamentoArquivo"
                    checked={ConcluirNoFechamentoArquivo}
                    onChange={this.onChangeCheck}
                  />
                </div>
                <div className="bx--col-md-12 bx--col-xs-12 mg-left-20">
                  <Checkbox
                    className=" check-uniq"
                    labelText="Tornar opcional 'Data desejada' no carrinho"
                    id="DataDesejadaOpcional"
                    name="DataDesejadaOpcional"
                    checked={DataDesejadaOpcional}
                    onChange={this.onChangeCheck}
                  />
                </div>
                <div className="bx--col-md-12 bx--col-xs-12 mg-left-20">
                  <Checkbox
                    className=" check-uniq"
                    labelText="Tornar opcional 'Forma de pagamento'"
                    id="FormaPagamentoOpcional"
                    name="FormaPagamentoOpcional"
                    checked={FormaPagamentoOpcional}
                    onChange={this.onChangeCheck}
                  />
                </div>
                <div className="bx--col-md-12 bx--col-xs-12 mg-left-20">
                  <Checkbox
                    className=" check-uniq"
                    labelText="Disponível em campanha promocional"
                    id="UtilizadoEmTrade"
                    name="UtilizadoEmTrade"
                    checked={UtilizadoEmTrade}
                    onChange={this.onChangeCheck}
                  />
                </div>
                <div className="bx--col-md-12 bx--col-xs-12 mg-left-20">
                  <Checkbox
                    className=" check-uniq"
                    labelText="Tornar opcional logistica"
                    id="Logistica"
                    name="Logistica"
                    checked={Logistica}
                    onChange={this.onChangeCheck}
                  />
                </div>
              </div>
            )
            }
            {manager === 'category' && (
              <div className="bx--row mg-left-20">
                <div className="bx--col-xs-12 bx--col-md-6">
                  <div className="bx--form-item">
                    <label className="bx--label v-md-margin">Descrição </label>
                    <textarea
                      className="bx--text-area"
                      rows="4"
                      cols="50"
                      required
                      placeholder="Digite aqui a descrição"
                      name="description"
                      value={description}
                      onChange={this.onChangeText}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="bx--row mg-left-20 ">
              <div className="bx--col-xs-12 v-md-margin v-lg-margin">
                <button tabIndex="0" className="bx--btn btn-secondary-color" type="submit">
                  Salvar
                </button>
                <button
                  tabIndex="0"
                  className="h-sm-margin bx--btn btn-secondary-outlined"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </Card>

        <Modal
          className="some-class"
          open={openMdDelete}
          modalHeading="Remover Item"
          primaryButtonText="Tenho certeza"
          secondaryButtonText="Cancelar"
          iconDescription="Cancelar e fechar"
          onRequestClose={() => this.modalDelete()}
          onRequestSubmit={() => this.delete()}
        >
          <p className="bx--modal-content__text">Você tem certeza que deseja deletar este item?</p>
        </Modal>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/ManageGroups/Edit.js